import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { ServiceGridItemObject } from '@it2go/types';
import { EmploymentContractEnum } from '@libs/types/src/user/enum/employment-contract.enum';

@Injectable()
export class UserEmploymentDialogStore extends ComponentStoreV2Factory {
    public services = computed(() => {
        return this.globalGlobalStore.organizationStore.services()
            .filter((it: ServiceGridItemObject) =>
                this.isAllowedForService('user.update', it.id)() ||
                this.isAllowedForService('user.create', it.id)());
    })
}
